var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C22.7739 0 27.3523 1.90785 30.7279 5.30385C34.1036 8.69985 36 13.3058 36 18.1085C36 25.7605 30.6554 34.0997 20.1046 43.2152C19.518 43.7222 18.77 44.0007 17.9965 44C17.2231 43.9993 16.4756 43.7195 15.8898 43.2115L15.192 42.6023C5.10831 33.7245 0 25.5896 0 18.1085C0 13.3058 1.89642 8.69985 5.27208 5.30385C8.64773 1.90785 13.2261 0 18 0ZM18 11.1437C16.1639 11.1437 14.403 11.8775 13.1046 13.1836C11.8063 14.4898 11.0769 16.2613 11.0769 18.1085C11.0769 19.9557 11.8063 21.7272 13.1046 23.0333C14.403 24.3395 16.1639 25.0733 18 25.0733C19.8361 25.0733 21.597 24.3395 22.8954 23.0333C24.1937 21.7272 24.9231 19.9557 24.9231 18.1085C24.9231 16.2613 24.1937 14.4898 22.8954 13.1836C21.597 11.8775 19.8361 11.1437 18 11.1437Z",
    fill: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationColored);
export default __webpack_public_path__ + "static/media/location-colored.62a007c97085a536eccb65ed809a754a.svg";
export { ForwardRef as ReactComponent };